import HealthAndSafetyOutlined from '@mui/icons-material/HealthAndSafetyOutlined'

import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@components/_mui/Typography'

import Section from '@components/Details/Section'

import Field from './Field'

export default function PatientCare({ ruleSets, ruleSetsAreLoading, cbo, supportsCashPay, cboIsLoading }) {
  const patientCare = ruleSets?.patientCare
  const providerTypes = cbo?.cbosProviderTypes || []

  return (
    <Section title="Patient Care" icon={<HealthAndSafetyOutlined />}>
      <Stack sx={{ gap: 1 }}>
        <Field
          label="Q Care Plus Services"
          isLoading={cboIsLoading}
          value={
            providerTypes.length > 0 && (
              <Stack sx={{ gap: 0.5 }}>
                {providerTypes.map((type) => (
                  <ProviderType key={type.name} type={type} supportsCashPay={supportsCashPay} />
                ))}
              </Stack>
            )
          }
        />
        <Field label="Lab Vendors Available" isLoading={cboIsLoading} value={cbo?.labVendors?.map((vendor) => vendor.name).join(', ')} />
        <Field label="STI Reporting" isLoading={ruleSetsAreLoading} value={patientCare?.stiReporting} />
        <Field label="pos. Chlamydia" isLoading={ruleSetsAreLoading} value={patientCare?.posChlamydia} />
        <Field label="pos. Gonorrhea" isLoading={ruleSetsAreLoading} value={patientCare?.posGonorrhea} />
        <Field label="pos. Syphilis" isLoading={ruleSetsAreLoading} value={patientCare?.posSyphilis} />
        <Field label="pos. HIV" isLoading={ruleSetsAreLoading} value={patientCare?.posHIV} />
      </Stack>
    </Section>
  )
}

function ProviderType({ type, supportsCashPay }) {
  const services = [
    { text: 'Async Messaging', isPreferred: false, show: type.asyncMessaging },
    { text: 'On Demand', isPreferred: type.preferOnDemand, show: type.onDemand },
    { text: 'Scheduling', isPreferred: false, show: type.scheduling },
    { text: 'Cash Pay', isPreferred: false, show: type.cashPay && supportsCashPay },
    { text: 'GLP-1', isPreferred: false, show: type.glp1 },
  ].filter((service) => service.show)

  return (
    <Box>
      <Typography component="span" sx={{ fontWeight: 'bold' }}>
        {type.name}
      </Typography>
      {services.length > 0 && (
        <Typography variant="body2" component="span" sx={{ ml: 1, color: 'text.secondary' }}>
          (
          {services.map((service, i) => (
            <Typography
              key={service.text}
              component="span"
              variant="body2"
              sx={{
                color: 'text.secondary',
                textDecoration: service.isPreferred ? 'underline' : 'none',
                fontWeight: service.isPreferred ? 'bold' : 'normal',
              }}
            >
              {service.text}
              {i < services.length - 1 ? ', ' : ''}
            </Typography>
          ))}
          )
        </Typography>
      )}
    </Box>
  )
}
